import { Link } from "react-router-dom";

interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  actionTo?: string;
  onAction?: () => void;
}

export default function EmptyState({
  icon = "ri-inbox-line",
  title,
  description,
  actionLabel,
  actionTo,
  onAction,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 rounded-lg border border-dashed border-background-300 bg-background-50 px-6 py-16 text-center">
      <div className="flex h-14 w-14 items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
        <i className={`${icon} text-2xl`}></i>
      </div>
      <h3 className="font-heading text-lg font-bold text-foreground-900">{title}</h3>
      {description && (
        <p className="max-w-md text-sm leading-relaxed text-foreground-600">{description}</p>
      )}
      {actionLabel && actionTo && (
        <Link
          to={actionTo}
          className="mt-2 inline-flex items-center gap-1.5 rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950"
        >
          {actionLabel}
          <i className="ri-arrow-right-line"></i>
        </Link>
      )}
      {actionLabel && !actionTo && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-2 inline-flex items-center gap-1.5 rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950"
        >
          <i className="ri-refresh-line"></i>
          {actionLabel}
        </button>
      )}
    </div>
  );
}